import React, { Fragment } from 'react'
import DeleteBtn from '../../buttons/DeleteBtn'
import EditBtn from '../../buttons/EditBtn'
import NullMssg from '../../common/NullMssg'
import { mssgs } from '../../../constantes/mssgs'
import _ from 'lodash'

const PositionsList = (
    {
        allPositions,
        handleRemove,
        openEditModal
    }
) => {

    allPositions = _.orderBy(allPositions, ['nombre'],['asc'])

    return (
        <Fragment>
            <table>
                <thead>
                    <tr>
                        <th>
                            Nombre
                        </th>
                        <th className="table-th-actions" style={{ width: '120px', minWidth: '120px' }}>
                            Acciones
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        allPositions.length > 0 ? allPositions.map((position, i) =>
                            <tr key={i}>
                                <td>
                                    {position.nombre}
                                </td>
                                <td className="table-td-actions">
                                    <button onClick={() => openEditModal(position.id_TipoCargo)}><EditBtn /></button>
                                    <button onClick={() => handleRemove(position.id_TipoCargo)}><DeleteBtn /></button>
                                </td>
                            </tr>
                        ) : <NullMssg mssg={mssgs.NADA_QUE_MOSTRAR_AÑADIR_CARGOS}/>
                    }
                </tbody>
            </table>
        </Fragment>
    )
}

export default PositionsList